import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersMeetingNoteTemplateMutateType,
  ApiManagersMeetingNoteTemplateMutateRequestType,
} from "~/domains";

type RequestDataType = {
  body: ApiManagersMeetingNoteTemplateMutateRequestType;
};

const request = ({ body }: RequestDataType) => {
  return new ApiClient()
    .post<ApiManagersMeetingNoteTemplateMutateType>(
      "/api/managers/meeting_note_templates",
      {
        meetingNoteTemplate: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersMeetingNoteTemplatesCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersMeetingNoteTemplateMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
